// ©2024 Austin App House. All rights reserved.
import React, { useState } from 'react';
import { connect } from 'react-redux';
import { getContractorTaxInfo, getContractorBankingInfo, changeDefaultDistance } from '../../../../storage/actions/profile';
import { toggleModal } from '../../../../storage/actions/modalsActions';
import InputRange from '../../../dashboard/inputRange';

const ButtonControl = ({
  profile,
  toggleModal,
  getContractorTaxInfo,
  getContractorBankingInfo,
  changeDefaultDistance
}) => {

  const [range, changeRange] = useState(profile.defaultDistance || 60)
  const handleSetDefaultRange =  () => {
     changeDefaultDistance(range)
  }
  const openTaxInformationModal = () => {
    getContractorTaxInfo()
      .then(res => {
        if (res?.data?.success) toggleModal(true, 'contractorTaxInformationModal');
      });
  };

  const openBankingInformationModal = () => {
    getContractorBankingInfo()
      .then(res => {
        if (res?.data?.success) toggleModal(true, 'addBankInfoForContractor');
      });
  };

  return (
    <>
    <div className='content'>
      <div className='field_row'>
        <button
            className="standard_btn light_btn"
            onClick={openTaxInformationModal}
        >
          Tax Info
        </button>
        {
          // eslint-disable-next-line no-nested-ternary
          !profile?.policingAgreements
            ? (
              <button
                  className="standard_btn light_btn"
                  onClick={() => toggleModal(true, 'acceptAgreements')}
              >
                Policing Agreements Update Required
              </button>
            )
            : (
              <button
                  className="standard_btn light_btn"
                  onClick={openBankingInformationModal}
              >
                Banking Information
              </button>
            )
        }
      </div>
    </div>
    <div>
      <div className='content'>
        Work Available Email Notification Radius
      </div>
      <div>
        <InputRange defaultValue={range} handler={changeRange} />
      </div>
      <div className={'content'}>
        <button
          className="standard_btn light_btn"
          style={{ height: 'calc(100% - 16px)' }}
          color="info"
          onClick={() => handleSetDefaultRange()}
        >
          Save
        </button>
      </div>
    </div>
  </>);
};

const mapDispatchToProps = {
  toggleModal,
  getContractorTaxInfo,
  getContractorBankingInfo,
  changeDefaultDistance
};

export default connect(null, mapDispatchToProps)(ButtonControl);
